import { render, staticRenderFns } from "./RadioTextInput.vue?vue&type=template&id=3397fdf3&scoped=true&"
import script from "./RadioTextInput.vue?vue&type=script&lang=js&"
export * from "./RadioTextInput.vue?vue&type=script&lang=js&"
import style0 from "./RadioTextInput.vue?vue&type=style&index=0&id=3397fdf3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3397fdf3",
  null
  
)

export default component.exports